/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { DelCustomerVO } from '@well/domain';
import { ShipmentDtoModel } from '../index';

export class ShipmentCustomerTemplateDTO extends ShipmentDtoModel {

  customerVO: DelCustomerVO | undefined = undefined;
  requestingCompanyLeUuid: string | undefined = undefined;

  constructor() {
    super();
    this.customerVO = new DelCustomerVO();
  }
}

